// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bArB","buttons":"styles_buttons__CxOg2"};